/**
 * Pseudowortbanken aus der bisherigen Blitzlesen-Übung.
 *
 * Die Bänke bleiben getrennt, weil die Auswahl in der Oberfläche bewusst
 * zwischen ein- und zweisilbigen Pseudowörtern unterscheidet.
 */
export const PSEUDOWOERTER_1 = [
  "bam", "baf", "bek", "bim", "bof", "buk", "daf", "dek", "dif", "dok",
  "dum", "fam", "fek", "fim", "fok", "fum", "gaf", "gek", "gim", "gok",
  "gum", "haf", "hek", "him", "hif", "hum", "jaf", "jek", "jok", "jum",
  "kaf", "keb", "kif", "kom", "kum", "laf", "lek", "lim", "lof", "lum",
  "maf", "mek", "mif", "mok", "mup", "naf", "nek", "nif", "nop", "num",
  "paf", "pek", "pim", "pof", "pum", "raf", "rek", "rif", "rof", "rup",
  "saf", "sek", "sim", "sof", "sum", "taf", "tek", "tif", "tof", "tum",
  "waf", "wek", "wim", "wok", "wum", "zaf", "zek", "zif", "zof", "zup",
  "blaf", "blek", "blim", "brof", "brum", "flak", "flem", "flim", "frak", "frok",
  "klaf", "klem", "klim", "plaf", "plek", "scham", "schek", "schim", "spaf", "stom",
] as const;

export const PSEUDOWOERTER_2 = [
  "bamo", "bafi", "beka", "bimo", "boku", "budel", "dafi", "deko", "dima", "doku",
  "dumo", "fami", "feko", "fima", "foku", "fumo", "gafi", "geko", "gima", "goki",
  "gumo", "hafi", "heko", "hima", "hofu", "humo", "jafi", "jeko", "joka", "jumo",
  "kafi", "kebo", "kima", "komu", "kumo", "lafi", "leko", "lima", "lofu", "lumo",
  "mafi", "meko", "mifa", "moku", "mupa", "nafi", "neko", "nifa", "nopu", "numa",
  "pafi", "peko", "pima", "pofu", "puma", "rafi", "reko", "rima", "rofu", "ruma",
  "safi", "seko", "sima", "sofu", "suma", "tafi", "teko", "tima", "tofa", "tuma",
  "wafi", "weko", "wima", "woku", "wuma", "zafi", "zeko", "zima", "zofu", "zuma",
  "balu", "belo", "bini", "bora", "buse", "dalo", "deni", "dira", "dolu", "duma",
  "falo", "feni", "fira", "folu", "fuma", "galo", "geni", "gira", "golu", "guma",
] as const;

export const PSEUDOWOERTER = [...PSEUDOWOERTER_1, ...PSEUDOWOERTER_2] as const;
